import ASfCallingActionButton from './index.vue';

ASfCallingActionButton.install = app => {
  app.component(ASfCallingActionButton.name, ASfCallingActionButton);
};

export default ASfCallingActionButton;
